import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from 'sushiweb/Button';
import Modal from 'sushiweb/Modal';
import PropTypes from 'prop-types';
import _get from 'lodash-es/get';
import _noop from 'lodash-es/noop';
import grey from 'sushiweb/tokens/color/grey';
import Layout from 'sushiweb/Layout';
import H6 from 'sushiweb/Typography/Heading/H6';
import { P } from 'sushiweb/Typography/Text';
import Download from 'sushiweb/Icons/all/Download';
import ChipsWrapper from 'sushiweb/InputTypes/Chips';
import CheckCircleFill from 'sushiweb/Icons/all/CheckCircleFill';
import green from 'sushiweb/tokens/color/green';
import H5 from 'sushiweb/Typography/Heading/H5';
import TimeFill from 'sushiweb/Icons/all/TimeFill';
import orange from 'sushiweb/tokens/color/orange';
import Switch from 'sushiweb/Switch';
import Dropdown from 'sushiweb/Dropdown/Dropdown';
import MenuItem from 'sushiweb/MenuItem/MenuItem';
import { validateEmail } from '../../../../utility';
import {
  ButtonWrapper,
  ClearFileUploadCrossWrapper,
  CreateButtonWrapper,
  CreateGroupModalFooter,
  CreateTeamHelperText,
  InputWrapper,
  ModalFieldsWrapper,
  ModalSuccessWrapper,
  StyledInput,
  TextWrapper,
  UnsuccessfulDownloadBtn,
  UnsuccessfulDownloadText,
  UnsuccessfulUploadText,
  UploadFileWrapper,
  UploadIconWhite,
  UploadSectionContainer,
  clearFileBtnStyle,
  chipsStyle,
  disabledUploadBtnStyle,
  downloadBtnStyle,
  uploadBtnStyle,
  uploadFileText,
  ChipsConatiner,
  StyledDisabledInput,
  StyledStatusWraper,
  CycleToggleText,
  ReviewGroupModalFooter,
} from './styles';
import {
  checkFileTypeSize,
  clearInputValue,
  downloadGroupCSV,
  downloadMultiOfficesCSV,
  formatAmountInRupees,
  formatDateinDDMMMYYY,
  getFormattedEndDate,
  getReviewProgramCycleAmount,
} from '../../../../helpers';
import {
  DASHBOARD,
  applicableFlowTypes,
  currentFlowTypeEnum,
  cycleTypeEnum,
  genericErrorMsg,
  groupUploadErrMsg,
  groupUploadMsg,
  uploadErrorStatus,
  uploadSuccessStatus,
  wrongFormat,
} from '../constants';
import usePolling from '../../utils/usePolling';
import { UPLOAD_GROUP_URL } from '../../../../constants/urls';
import { ConfirmUpload, UploadsContainer } from '../../styles';
import { EMPLOYEES_ROUTE } from '../../../../constants/routes';
import {
  ClearFileUploadCross,
  FileSVG,
  FundsSummaryIcon,
  SingleLineArrow,
} from '../../../../components/SVGs/commonSVGs';
import { FundsSummaryText } from '../../../WalletPrograms/styles';
import { frequencyTypes } from '../../../WalletPrograms/constants';
import ZTrackingClient from '../../../../jumbo/ZTrackingClient';

const CreateGroupModal = ({
  currentFlow,
  currentTab,
  clearCreateGroup,
  selectedWorkspace,
  showErrorToast,
  isVisible,
  closeModal,
  heading,
  processId,
  createGroup,
  creatingGroup,
  groupCreated,
  setFileUploadMsg,
  uploadMsg,
  groupEmployees,
  isAddEmployeeToGroup,
  createGroupDetails,
  confirmGroup,
  confirmingGroup,
  setAddEmployeeTopupCycle,
  confirmAddEmlpoyeeTopupCycle,
  clearAddEmployeeTopupCycle,
  mappedOffices,
  companyData,
}) => {
  const [name, setName] = useState('');
  const [gst, setGst] = useState('');
  const [selectedOffice, setSelectedOffice] = useState(null);
  const [emailList, setEmailList] = useState([]);
  const [file, setFile] = useState(null);
  const [inputDisabled, setInputDisabled] = useState(false);
  const [uploadStatus, setUploadStatus] = useState('');
  const [uploadData, setUploadData] = useState([]);
  const [isPollingStarted, setIsPollingStarted] = useState(false);
  const [pollingFrequency, setPollingFrequency] = useState(2);
  const [isPlanMapped, setIsPlanMapped] = useState(false);
  const [reqBody, setReqBody] = useState({});
  const url = UPLOAD_GROUP_URL;
  const hasNameOrGroupName = !!(groupEmployees?.group_name || name);
  const hasInputEmails = emailList.length !== 0;
  const isFileProvided = file !== null;
  const hasGST = gst !== '';
  const showProgressBar = uploadStatus === '' || uploadStatus === 'completed';
  let successful = '';
  let unsuccessful = '';
  let unsuccessfulLink = '';

  const updateName = val => {
    if (val.length <= 50) {
      setName(val);
    }
  };
  const isEmployeeGSTMappingFeatureEnabled = () => {
    return (
      companyData?.meta_data?.is_employee_gst_mapping_enabled &&
      mappedOffices.length > 1
    );
  };

  const handleGSTSelect = selectedOffc => {
    setGst(selectedOffc.gst_number);
    setSelectedOffice(selectedOffc);
  };

  const getGSTMenuLabel = office => (
    <div>
      <b>{office.state_name}</b>
      <br />
      {office.gst_number}
    </div>
  );

  const handleClearFileClick = () => {
    setFile(null);
  };

  const closeModalConfirm = () => {
    clearAddEmployeeTopupCycle();
    closeModal();
  };

  const addEmailList = val => {
    if (validateEmail(val)) {
      setEmailList([...emailList, val]);
    }
  };

  const removeEmailList = val => {
    const updatedEmailList = [...emailList];
    updatedEmailList.splice(val, 1);
    setEmailList(updatedEmailList);
  };

  const emailCheck = val => {
    return validateEmail(val);
  };

  useEffect(() => {
    ZTrackingClient.recordImpression({
      ui_source: isAddEmployeeToGroup
        ? 'ADD_EMPLOYEE_TO_TEAM'
        : 'CREATE_NEW_TEAM_MODAL',
      component: 'MODAL',
    });
  }, []);

  useEffect(() => {
    if (groupCreated) {
      setIsPollingStarted(true);
      setInputDisabled(true);
    }
  }, [groupCreated]);

  useEffect(() => {
    if (uploadStatus === 'completed') {
      setIsPollingStarted(false);
      clearCreateGroup();
      if (isPlanMapped) {
        const newReviewProgramBody = {
          to_be_added_in_current_cycle: currentCycle,
          to_be_given_pro_rated_amount: giveProRatedAmount,
          ...reqBody,
        };
        confirmGroup(newReviewProgramBody);
      }
    } else if (uploadStatus === 'failed') {
      clearCreateGroup();
    }
  }, [uploadStatus, isPlanMapped, reqBody]);

  const TopScroll = () => {
    const successRef = useRef();
    useEffect(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
    return <div ref={successRef} />;
  };

  const onResponse = ({ isError, response }) => {
    let message = '';
    const status = _get(response, 'data.status', '');
    const uploads = _get(response, 'data.uploads', []);
    const planMappedData = _get(response, 'data.is_plan_mapped', false);
    setUploadData(uploads);
    setUploadStatus(status);
    setIsPlanMapped(planMappedData);
    const body = {
      process_id: processId,
      workspace_id: selectedWorkspace.workspace_id,
      group_id: groupEmployees?.group_id,
    };
    setReqBody(body);

    if (uploadSuccessStatus.includes(status)) {
      message = _get(response, 'data.message.title', groupUploadMsg);
    } else {
      message = _get(response, 'data.message.title', genericErrorMsg);
    }
    setFileUploadMsg(message);
    if (isError) {
      setIsPollingStarted(false);
      setFileUploadMsg(groupUploadErrMsg);
      setUploadStatus('failed');
      return;
    }
    if (uploadSuccessStatus.includes(status) && !isError) {
      setPollingFrequency(3);
    } else {
      setIsPollingStarted(false);
    }
  };

  usePolling({
    processId,
    frequency: pollingFrequency,
    isPollingStarted,
    onResponse,
    url,
  });

  const onChange = e => {
    checkFileTypeSize(e.target.files[0])
      .then(success => {
        if (success) {
          setFile(e.target.files[0]);
        } else {
          showErrorToast(wrongFormat);
          clearInputValue();
        }
      })
      .catch(err => {
        clearInputValue();
        showErrorToast();
        console.log(err);
      });
  };
  const appendHeaderAndconvertEmployeeGSTArrayToCSV = emails => {
    const header = ['emailid', 'gstin'];
    const dataRows = emails.map(email => [email, gst.split(' ')[0]]);
    const csvRows = [header, ...dataRows];
    const csvContent = csvRows
      .map(row => row.map(item => `"${item}"`).join(',')) // Wrap each item in quotes and join by comma
      .join('\n');

    return csvContent;
  };

  const appendHeaderAndconvertArrayToCSV = emails => {
    const FinalEmails = ['emailid', ...emails];
    const csvContent = FinalEmails.map(row => `"${row}"`).join('\n');
    return csvContent;
  };

  const getCsvData = () => {
    return isEmployeeGSTMappingFeatureEnabled()
      ? appendHeaderAndconvertEmployeeGSTArrayToCSV(emailList)
      : appendHeaderAndconvertArrayToCSV(emailList);
  };

  const goNextForEmailChips = () => {
    const blob = new Blob([getCsvData()], { type: 'text/csv' });
    const fileBody = new FormData();
    if (isAddEmployeeToGroup) {
      fileBody.append('group_id', groupEmployees?.group_id);
      fileBody.append('file', blob);
    } else {
      fileBody.append('name', name);
      fileBody.append('file', blob);
    }
    createGroup({
      fileBody,
      workspaceId: selectedWorkspace.workspace_id ?? '',
      flowType: currentFlow,
    });
    ZTrackingClient.recordClick({
      ui_source: isAddEmployeeToGroup
        ? 'ADD_EMPLOYEE_TO_TEAM'
        : 'CREATE_NEW_TEAM_MODAL',
      component: isAddEmployeeToGroup ? 'ADD_EMPLOYEE' : 'ADD_TEAM',
    });
  };

  const goNext = () => {
    const fileBody = new FormData();
    if (isAddEmployeeToGroup) {
      fileBody.append('group_id', groupEmployees.group_id);
      fileBody.append('file', file);
    } else {
      fileBody.append('name', name);
      fileBody.append('file', file);
    }
    createGroup({
      fileBody,
      workspaceId: selectedWorkspace.workspace_id ?? '',
      flowType: currentFlow,
    });
    ZTrackingClient.recordClick({
      ui_source: isAddEmployeeToGroup
        ? 'ADD_EMPLOYEE_TO_TEAM'
        : 'CREATE_NEW_TEAM_MODAL',
      component: isAddEmployeeToGroup ? 'ADD_EMPLOYEE' : 'ADD_TEAM',
    });
  };

  const isButtonEnabled = () => {
    if (isEmployeeGSTMappingFeatureEnabled()) {
      return (
        hasNameOrGroupName && (isFileProvided || (hasInputEmails && hasGST))
      );
    }
    return hasNameOrGroupName && (isFileProvided || hasInputEmails);
  };

  const isFileUploadDisabled = () => {
    if (!isEmployeeGSTMappingFeatureEnabled()) {
      return inputDisabled || hasInputEmails;
    }
    return inputDisabled || hasInputEmails || hasGST;
  };

  const emailListDisabled = inputDisabled || file;

  const [currentCycle, setCurrentCycle] = useState(true);
  const [giveProRatedAmount, setGiveProRatedAmount] = useState(false);
  const handleCycleChange = () => {
    if (currentCycle) {
      setGiveProRatedAmount(false);
    }
    setCurrentCycle(!currentCycle);
  };

  const handleConfirmClick = () => {
    const newReviewProgramBody = {
      to_be_added_in_current_cycle: currentCycle,
      to_be_given_pro_rated_amount: giveProRatedAmount,
      ...reqBody,
    };
    setAddEmployeeTopupCycle(newReviewProgramBody);
  };

  // const handleProRatedAmountChange = () => {
  //   setGiveProRatedAmount(!giveProRatedAmount);
  // };
  const {
    name: programName = '-',
    monthly_amount: amountMonthly = '',
    weekly_amount: amountWeekly = '',
    daily_amount: amountDaily = '',
    period: periodCycle = '-',
    payable_amount: payableAmount = '-',
    total_group_employees: totalEmployees = '-',
    start_date: startDate = '-',
    end_date: endDate = '-',
    cycle_type: cycleType = '-',
  } = createGroupDetails;

  useEffect(() => {
    if (uploadStatus === 'completed' && !isPollingStarted && isPlanMapped) {
      const newReviewProgramBody = {
        to_be_added_in_current_cycle: currentCycle,
        to_be_given_pro_rated_amount: giveProRatedAmount,
        ...reqBody,
      };
      confirmGroup(newReviewProgramBody);
    }
  }, [currentCycle, giveProRatedAmount]);

  const rendorEmployeeUpdateModal = () => {
    return (
      <ModalFieldsWrapper>
        <ConfirmUpload
          status={uploadStatus}
          progress={isPollingStarted}
          show={!showProgressBar || isPollingStarted || creatingGroup}
        >
          {uploadMsg}
        </ConfirmUpload>
        {!['failed', 'completed', 'terminated'].includes(uploadStatus) && (
          <UploadSectionContainer>
            <Layout>
              <Layout.Item colD={12} colT={12} colM={12}>
                <InputWrapper>
                  <StyledInput
                    innerWidth='100%'
                    label='Enter team name'
                    value={
                      isAddEmployeeToGroup ? groupEmployees.group_name : name
                    }
                    onChange={updateName}
                    type='text'
                    disabled={inputDisabled || isAddEmployeeToGroup}
                  />
                  <CreateTeamHelperText>
                    {' '}
                    Eg- Sales_GGN, Human Resources, All
                    {' '}
                  </CreateTeamHelperText>
                </InputWrapper>
              </Layout.Item>
            </Layout>
            <UploadFileWrapper>
              <Layout>
                <Layout.Item colD={12} colT={12} colM={12}>
                  <ChipsConatiner>
                    {mappedOffices && isEmployeeGSTMappingFeatureEnabled() && (
                      <>
                        <Dropdown
                          width='100'
                          placeholder='Select GST'
                          value={
                            gst ? `${gst} ${selectedOffice?.state_name}` : ''
                          }
                          customPadding='0 20px 0 12px'
                          onSelect={handleGSTSelect}
                        >
                          {mappedOffices.map(office => (
                            <MenuItem
                              key={office.office_id}
                              value={office}
                              label={getGSTMenuLabel(office)}
                            />
                          ))}
                        </Dropdown>

                        <div style={{ fontSize: 10, color: grey.z600 }}>
                          Please select a GST Number
                        </div>
                      </>
                    )}
                  </ChipsConatiner>
                </Layout.Item>
                <Layout.Item colD={12} colT={12} colM={12}>
                  <ChipsConatiner>
                    <ChipsWrapper
                      activeColors={chipsStyle}
                      inertColors={chipsStyle}
                      label='Add employee email ID(s)'
                      useBackSpace
                      list={emailList}
                      onAdd={addEmailList}
                      onRemove={removeEmailList}
                      helperText='Use comma or space to add multiple email IDs'
                      errorText='Please enter valid email ID'
                      validator={emailCheck}
                      disabled={emailListDisabled}
                    />
                  </ChipsConatiner>
                </Layout.Item>
                <Layout.Item colD={6} colT={6} colM={6}>
                  {' '}
                </Layout.Item>
                <Layout.Item colD={6} colT={6} colM={6}>
                  <H6>OR</H6>
                </Layout.Item>
                <Layout.Item colD={12} colT={12} colM={12}>
                  <ButtonWrapper>
                    <label
                      htmlFor='upload-file'
                      style={
                        isFileUploadDisabled() || file
                          ? disabledUploadBtnStyle
                          : uploadBtnStyle
                      }
                    >
                      <input
                        style={{
                          display: 'inline-block',
                          width: '100%',
                          padding: '120px 0 0 0',
                          height: '100px',
                          overflow: 'hidden',
                          zIndex: 2,
                          cursor:
                            !isFileUploadDisabled() && !file
                              ? 'pointer'
                              : 'default',
                        }}
                        id='upload-file'
                        type='file'
                        accept='.csv'
                        onChange={onChange}
                        disabled={isFileUploadDisabled() || file}
                      />
                      <H6
                        style={
                          isFileUploadDisabled() || file
                            ? {
                                color: '#9197A6',
                                cursor: 'default',
                                ...uploadFileText,
                              }
                            : {
                                color: '#EF4F5F',
                                cursor: 'pointer',
                                ...uploadFileText,
                              }
                        }
                      >
                        Upload employee list
                      </H6>
                    </label>
                  </ButtonWrapper>
                </Layout.Item>
                <Layout.Item colD={7.5} colT={7.5} colM={7.5}>
                  <TextWrapper>
                    {file != null && (
                      <div>
                        <P> 1 File selected </P>
                        <ClearFileUploadCrossWrapper>
                          <FileSVG />
                          <H6 style={{ paddingLeft: '5px', marginTop: '-8px' }}>
                            {' '}
                            {file.name}
                          </H6>
                          <Button
                            appearance='outline'
                            style={clearFileBtnStyle}
                            onClick={handleClearFileClick}
                            icon={<ClearFileUploadCross />}
                          />
                        </ClearFileUploadCrossWrapper>
                      </div>
                    )}
                    <P> &#x2022; Only .csv files supported</P>
                    <P> &#x2022; File size upto 5MB</P>
                    <P>
                      &#x2022;
                      {' '}
                      {isEmployeeGSTMappingFeatureEnabled()
                        ? 'Only registered domain email IDs & GST will be accepted'
                        : 'Only registered domain email IDs will be accepted'}
                    </P>
                  </TextWrapper>
                </Layout.Item>
                <Layout.Item colD={3.4} colT={7.5} colM={7.5}>
                  <Button
                    appearance='outline'
                    style={downloadBtnStyle}
                    onClick={() => {
                      if (isEmployeeGSTMappingFeatureEnabled()) {
                        downloadMultiOfficesCSV();
                      } else {
                        downloadGroupCSV();
                      }
                    }}
                    icon={<Download />}
                    btnColor='coal'
                    iconAlign='left'
                  >
                    Download sample file
                  </Button>
                </Layout.Item>
              </Layout>
            </UploadFileWrapper>

            <CreateButtonWrapper>
              <Button
                onClick={file != null ? goNext : goNextForEmailChips}
                loading={creatingGroup || isPollingStarted}
                disabled={!isButtonEnabled()}
                icon={<SingleLineArrow />}
                iconAlign='right'
              >
                Next
              </Button>
            </CreateButtonWrapper>
          </UploadSectionContainer>
        )}
        {(!showProgressBar || isPollingStarted || creatingGroup) && (
          <TopScroll />
        )}
        {uploadErrorStatus.includes(uploadStatus) && !isPollingStarted && (
          <UploadsContainer>
            <ModalSuccessWrapper>
              <TimeFill color={orange.z500} size='7rem' />
              ;
              <H5>Team Creation Failed</H5>
              <P>Add upto 5000 employees in one file</P>
              <Button
                appearance='outline'
                btnColor='red'
                style={{ marginBottom: '15px' }}
                onClick={goNext}
                loading={creatingGroup}
                disabled={!isButtonEnabled()}
              >
                Try Again
              </Button>
            </ModalSuccessWrapper>
          </UploadsContainer>
        )}
        {uploadStatus === 'completed' &&
          !isPollingStarted &&
          isPlanMapped &&
          !confirmAddEmlpoyeeTopupCycle && (
            <UploadsContainer>
              <ModalSuccessWrapper
                style={{ marginTop: '0', paddingBottom: '8rem' }}
              >
                <UploadSectionContainer>
                  <Layout.Item colD={12} colT={12} colM={12}>
                    {uploadData.forEach(uploadInfo => {
                      const {
                        title = '',
                        subtitle = '',
                        link = '',
                      } = uploadInfo;
                      if (title === 'Successful Uploads')
                        successful = subtitle.split(' ');
                      else if (title === 'Unsuccessful Uploads') {
                        unsuccessful = subtitle.split(' ');
                      }
                      if (unsuccessful[0] !== '0') {
                        unsuccessfulLink = link;
                      }
                    })}
                    <StyledStatusWraper unsuccessful={unsuccessful[0] !== '0'}>
                      <div>
                        <H5>
                          {successful[0]}
                          {' '}
                          employee(s) added successfully
                        </H5>
                        {unsuccessful[0] !== '0' && (
                          <H5>
                            {unsuccessful[0]}
                            {' '}
                            employee(s) could not be added,
                            download file to see why
                          </H5>
                        )}
                      </div>
                      {unsuccessful[0] !== '0' && (
                        <UnsuccessfulDownloadText
                          href={unsuccessfulLink}
                          target='_blank'
                          rel='noreferrer'
                        >
                          <UnsuccessfulDownloadBtn>
                            Download
                            <UploadIconWhite>
                              <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='16'
                                height='16'
                                viewBox='0 0 16 16'
                                fill='none'
                              >
                                <path
                                  d='M2 12.6654H14V13.9987H2V12.6654ZM8.66667 8.77977L12.7141 4.73236L13.6569 5.67518L8 11.332L2.34315 5.67518L3.28595 4.73236L7.33333 8.77977V1.33203H8.66667V8.77977Z'
                                  fill='#414A5D'
                                />
                              </svg>
                            </UploadIconWhite>
                          </UnsuccessfulDownloadBtn>
                        </UnsuccessfulDownloadText>
                      )}
                    </StyledStatusWraper>
                  </Layout.Item>
                  <Layout gap={30}>
                    <Layout.Item colD={12} colT={12} colM={12}>
                      <H5> Meal plan details</H5>
                    </Layout.Item>
                    <Layout.Item colD={12} colT={12} colM={12}>
                      <InputWrapper>
                        <StyledDisabledInput
                          label='Plan name'
                          value={programName}
                          disabled
                          showHelperText={false}
                        />
                      </InputWrapper>
                    </Layout.Item>
                    <Layout.Item colD={6} colT={12} colM={12}>
                      <InputWrapper>
                        <StyledDisabledInput
                          label='Start date'
                          value={formatDateinDDMMMYYY(startDate)}
                          disabled
                          showHelperText={false}
                        />
                      </InputWrapper>
                    </Layout.Item>
                    <Layout.Item colD={6} colT={12} colM={12}>
                      <InputWrapper>
                        <StyledDisabledInput
                          label='End date'
                          value={
                            getFormattedEndDate(endDate) !== 'NA'
                              ? formatDateinDDMMMYYY(endDate)
                              : 'NA'
                          }
                          disabled
                          showHelperText={false}
                        />
                      </InputWrapper>
                    </Layout.Item>
                    <Layout.Item colD={6} colT={4} colM={12}>
                      <InputWrapper>
                        <StyledDisabledInput
                          label='Frequency'
                          value={frequencyTypes[cycleType]}
                          disabled
                          showHelperText={false}
                        />
                      </InputWrapper>
                    </Layout.Item>
                    <Layout.Item colD={6} colT={4} colM={12}>
                      <InputWrapper>
                        <StyledDisabledInput
                          label='Budget/employee'
                          value={getReviewProgramCycleAmount(
                            cycleType,
                            amountWeekly,
                            amountMonthly,
                            amountDaily,
                          )}
                          disabled
                          showHelperText={false}
                        />
                      </InputWrapper>
                    </Layout.Item>
                    <Layout.Item colD={6} colT={4} colM={12}>
                      <InputWrapper>
                        <StyledDisabledInput
                          label='Employees count'
                          value={totalEmployees}
                          disabled
                          showHelperText={false}
                        />
                      </InputWrapper>
                    </Layout.Item>
                    <Layout.Item colD={6} colT={4} colM={12}>
                      <InputWrapper>
                        <StyledDisabledInput
                          label='Plan cycle'
                          value={periodCycle}
                          disabled
                          showHelperText={false}
                        />
                      </InputWrapper>
                    </Layout.Item>
                    {(cycleType === cycleTypeEnum.MONTHLY ||
                      cycleType === cycleTypeEnum.WEEKLY) && (
                      <>
                        <Layout.Item colD={12} colT={12} colM={12}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            <CycleToggleText>
                              <H6>
                                Allow benefits to be available in the current
                                cycle?
                              </H6>
                              <p>
                                If not selected, employees will start receiving
                                funds from next cycle
                              </p>
                            </CycleToggleText>
                            <Switch
                              active={currentCycle}
                              onToggle={handleCycleChange}
                            />
                          </div>
                        </Layout.Item>
                        {/* <Layout.Item colD={6} colT={12} colM={12}>
                        <Checkbox
                          checked={giveProRatedAmount}
                          onChange={handleProRatedAmountChange}
                          label='Give pro-rated amount'
                          disabled={!currentCycle}
                        />
                      </Layout.Item> */}
                      </>
                    )}
                  </Layout>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <FundsSummaryIcon />
                    <FundsSummaryText style={{ height: 'auto' }}>
                      <H5 style={{ marginTop: '0' }}>Funds summary</H5>
                      <P style={{ margin: '4px 0 0 0' }}>
                        Additional funds required &nbsp;
                        <H6>{formatAmountInRupees(payableAmount)}</H6>
                      </P>
                    </FundsSummaryText>
                  </div>
                  <ReviewGroupModalFooter>
                    <CreateButtonWrapper style={{ marginBottom: '0' }}>
                      <Button
                        onClick={handleConfirmClick}
                        loading={confirmingGroup}
                        disabled={!isButtonEnabled()}
                        icon={<SingleLineArrow />}
                        iconAlign='right'
                      >
                        Continue
                      </Button>
                    </CreateButtonWrapper>
                  </ReviewGroupModalFooter>
                </UploadSectionContainer>
              </ModalSuccessWrapper>
            </UploadsContainer>
          )}
        {uploadStatus === 'completed' &&
          !isPollingStarted &&
          (!isPlanMapped || (isPlanMapped && confirmAddEmlpoyeeTopupCycle)) && (
            <UploadsContainer>
              {uploadData.forEach(uploadInfo => {
                const { title = '', subtitle = '', link = '' } = uploadInfo;
                if (title === 'Successful Uploads')
                  successful = subtitle.split(' ');
                else if (title === 'Unsuccessful Uploads') {
                  unsuccessful = subtitle.split(' ');
                }
                if (unsuccessful[0] !== '0') {
                  unsuccessfulLink = link;
                }
              })}
              <ModalSuccessWrapper>
                <CheckCircleFill color={green.z500} size='7rem' />
                ;
                <H5>
                  {isAddEmployeeToGroup
                    ? 'Employees added successfully'
                    : 'Team created successfully'}
                </H5>
                {unsuccessful[0] !== '0' ? (
                  <P>
                    {successful[0]}
                    {' '}
                    {successful[0] === '0' || successful[0] === '1'
                      ? 'employee'
                      : 'employees'}
                    {' '}
                    added
                  </P>
                ) : (
                  <P>View your teams in the ‘Employees’ section</P>
                )}
                {currentTab === DASHBOARD ? (
                  <Link to={EMPLOYEES_ROUTE}>
                    <Button
                      style={{ marginBottom: '15px' }}
                      appearance='outline'
                      btnColor='red'
                    >
                      Go to ‘Employees’ section
                    </Button>
                  </Link>
                ) : (
                  <Button
                    style={{ marginBottom: '15px' }}
                    btnColor='red'
                    onClick={closeModalConfirm}
                  >
                    Done
                  </Button>
                )}
                {unsuccessful[0] !== '0' ? (
                  <CreateGroupModalFooter>
                    <UnsuccessfulUploadText>
                      <H5>
                        {unsuccessful[0]}
                        {' '}
                        {unsuccessful[0] === '0' || unsuccessful[0] === '1'
                          ? 'employee'
                          : 'employees'}
                        {' '}
                        could not be added
                      </H5>
                      <P>Download file to see why </P>
                    </UnsuccessfulUploadText>
                    <UnsuccessfulDownloadText
                      href={unsuccessfulLink}
                      target='_blank'
                      rel='noreferrer'
                    >
                      <UnsuccessfulDownloadBtn>
                        Download
                        <UploadIconWhite>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='16'
                            height='16'
                            viewBox='0 0 16 16'
                            fill='none'
                          >
                            <path
                              d='M2 12.6654H14V13.9987H2V12.6654ZM8.66667 8.77977L12.7141 4.73236L13.6569 5.67518L8 11.332L2.34315 5.67518L3.28595 4.73236L7.33333 8.77977V1.33203H8.66667V8.77977Z'
                              fill='#414A5D'
                            />
                          </svg>
                        </UploadIconWhite>
                      </UnsuccessfulDownloadBtn>
                    </UnsuccessfulDownloadText>
                  </CreateGroupModalFooter>
                ) : null}
              </ModalSuccessWrapper>
            </UploadsContainer>
          )}
      </ModalFieldsWrapper>
    );
  };

  return (
    <>
      <Modal
        isCentered
        visible={isVisible}
        onClose={closeModal}
        showCloseIcon={
          !['failed', 'completed', 'terminated'].includes(uploadStatus) ||
          (uploadErrorStatus.includes(uploadStatus) && !isPollingStarted)
        }
        title={heading}
        overlayClickClose={
          !['failed', 'completed', 'terminated'].includes(uploadStatus) ||
          (uploadErrorStatus.includes(uploadStatus) && !isPollingStarted)
        }
      >
        {rendorEmployeeUpdateModal()}
      </Modal>
    </>
  );
};

CreateGroupModal.propTypes = {
  currentFlow: PropTypes.oneOf(applicableFlowTypes),
  currentTab: PropTypes.string,
  clearCreateGroup: PropTypes.func,
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  isVisible: PropTypes.bool,
  closeModal: PropTypes.func,
  heading: PropTypes.string,
  showErrorToast: PropTypes.func,
  processId: PropTypes.string,
  createGroup: PropTypes.func,
  creatingGroup: PropTypes.bool,
  groupCreated: PropTypes.bool,
  setFileUploadMsg: PropTypes.func,
  uploadMsg: PropTypes.string,
  groupEmployees: PropTypes.objectOf(PropTypes.any),
  isAddEmployeeToGroup: PropTypes.bool,
  createGroupDetails: PropTypes.objectOf(PropTypes.any),
  confirmGroup: PropTypes.func,
  confirmingGroup: PropTypes.bool,
  setAddEmployeeTopupCycle: PropTypes.func,
  confirmAddEmlpoyeeTopupCycle: PropTypes.bool,
  clearAddEmployeeTopupCycle: PropTypes.func,
  mappedOffices: PropTypes.objectOf(PropTypes.any),
  companyData: PropTypes.objectOf(PropTypes.any),
};

CreateGroupModal.defaultProps = {
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_PPI,
  currentTab: '',
  clearCreateGroup: _noop,
  selectedWorkspace: {},
  isVisible: true,
  closeModal: _noop,
  heading: '',
  processId: '',
  uploadMsg: '',
  createGroup: _noop,
  creatingGroup: false,
  groupCreated: false,
  showErrorToast: _noop,
  setFileUploadMsg: _noop,
  groupEmployees: {},
  isAddEmployeeToGroup: false,
  createGroupDetails: {},
  confirmGroup: _noop,
  confirmingGroup: false,
  setAddEmployeeTopupCycle: _noop,
  confirmAddEmlpoyeeTopupCycle: false,
  clearAddEmployeeTopupCycle: _noop,
  mappedOffices: {},
  companyData: {},
};

export default CreateGroupModal;
